module.exports = __webpack_public_path__ + "static/img/6.82c8cb2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/7/eng/6.png
// module id = VXzn
// module chunks = 0